<template>
  <div class="report-content">
    <van-loading type="spinner" v-if="loading" vertical class="loading" />
    <div class="report-content-outer">
      <div class="customer-info" v-if="customerInfo">
        <div class="img-content">
          <img
            :src="
              (customerInfo.enterpriseLogo || defaultCustomerAvatar)
                | avatar('defaultCustomerAvatar')
            "
            v-img-error-customer
          />
        </div>
        <span class="title">{{ customerInfo.enterpriseName }}</span>
      </div>
      <ul v-if="list && list.length && !loading">
        <li :key="item.id" v-for="item in list">
          <div class="top-info">
            <div class="title-info">
              <h3>{{ item.title }}</h3>
              <span class="pa-name">PA：{{ item.paName }}</span>
            </div>
            <div class="split-info">
              <p class="split-line">
                <!-- <count-item
                  title="在线职位"
                  :current-num="item.onlineNum"
                  :change-num="item.onlineNumChange"
                ></count-item> -->
                <count-item
                  title="有效推荐"
                  :current-num="item.validRecommendCount"
                  :change-num="item.validRecommendCountChanged"
                ></count-item>
                <count-item
                  title="一面"
                  :current-num="item.interviewCount"
                  :change-num="item.interviewCountChanged"
                ></count-item>
              </p>
            </div>
          </div>
          <div class="bottom-info">
            <div class="bottom-left-info">
              <count-item
                title="offer"
                :current-num="item.offerCount"
                :change-num="item.offerCountChanged"
              ></count-item>
              <count-item
                title="到 岗"
                :current-num="item.onboardCount"
                :change-num="item.onboardCountChanged"
              ></count-item>
              <count-item
                title="过 保"
                :current-num="item.overGuaranteeCount"
                :change-num="item.overGuaranteeCountChanged"
              ></count-item>
            </div>
            <div class="bottom-right-info">
              <count-item
                title="offer-GMV"
                :current-num="item.offerGmv"
                :change-num="item.offerGmvChanged"
                :type="1"
              ></count-item>
              <count-item
                title="到 岗-GMV"
                :current-num="item.onboardGmv"
                :change-num="item.onboardGmvChanged"
                :type="1"
              ></count-item>
              <count-item
                title="过 保-GMV"
                :current-num="item.overGuaranteeGmv"
                :change-num="item.overGuaranteeGmvChanged"
                :type="1"
              ></count-item>
            </div>
          </div>
          <div class="last-bottom-info">
            <div class="split-info">
              <p class="split-line">
                <count-item
                  title="预计佣金"
                  :current-num="item.bdEstimateCommissionAmount"
                ></count-item>
                <count-item
                  title="实际佣金"
                  :current-num="item.bdActualCommissionAmount"
                ></count-item>
              </p>
            </div>
          </div>
        </li>
      </ul>
      <no-data v-if="(!list || !list.length) && !loading"></no-data>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.report-content {
  height: 100%;
  .customer-info {
    margin: 1.2rem 1rem;
    padding: 1.5rem;
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 1rem;
    .img-content {
      width: 5rem;
      height: 5rem;
      margin-right: 1rem;
      overflow: hidden;
      border-radius: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    span.title {
      font-size: 1.6rem;
      font-weight: 500;
      color: #333333;
    }
  }
  ul {
    li {
      margin: 1.2rem 1rem 0;
      padding: 1.5rem;
      background: #ffffff;
      border-radius: 1rem;
      &:first-child {
        margin-top: 1rem;
      }
      .top-info {
        padding-bottom: 1rem;
        border-bottom: 0.1rem solid #eeeeee;
        .title-info {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-bottom: 1rem;
          h3 {
            font-size: 1.7rem;
            font-weight: 500;
            color: #333333;
            max-width: 70%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .pa-name {
            font-size: 1.4rem;
            font-weight: 400;
            color: #666666;
            white-space: nowrap;
            overflow: hidden;
            max-width: 11.8rem;
            text-overflow: ellipsis;
          }
        }
        .split-info {
          p {
            font-size: 1.2rem;
            font-weight: 400;
            color: #666666;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &.split-line {
              position: relative;
              .count-item {
                width: 9.8rem;
                padding-right: 1rem;
                margin-right: 1rem;
                flex: 1;
                position: relative;
                color: #666;
                &::after {
                  content: "";
                  position: absolute;
                  height: 100%;
                  width: 0.1rem;
                  background: #eeeeee;
                  top: 0;
                  right: 0;
                }
                &:last-child {
                  margin-right: 0;
                  &::after {
                    content: none;
                  }
                }
              }
            }
          }
        }
      }
      .bottom-info {
        display: flex;
        padding-top: 1rem;
        font-size: 1.2rem;
        font-weight: 400;
        color: #333333;
        .bottom-left-info {
          display: flex;
          flex-direction: column;
          padding-right: 1rem;
          flex: 1;
          min-width: 9.3rem;
          .count-item {
            color: #333;
            margin-top: 2rem;
            &:first-child {
              margin-top: 0;
            }
          }
        }
        .bottom-right-info {
          display: flex;
          flex-direction: column;
          flex: 2.35;
          min-width: 2.22rem;
          .count-item {
            color: #333;
            margin-top: 2rem;
            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
      .last-bottom-info {
        padding-top: 1rem;
        border-top: 0.1rem solid #eeeeee;
        margin-top: 1rem;
        .split-info {
          p {
            font-size: 1.2rem;
            font-weight: 400;
            color: #666666;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &.split-line {
              position: relative;
              .count-item {
                width: 9.8rem;
                padding-right: 1rem;
                margin-right: 1rem;
                flex: 1;
                position: relative;
                color: #666;
                &::after {
                  content: "";
                  position: absolute;
                  height: 100%;
                  width: 0.1rem;
                  background: #eeeeee;
                  top: 0;
                  right: 0;
                }
                &:last-child {
                  margin-right: 0;
                  &::after {
                    content: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<script>
import CountItem from "./countItem";
import defaultCustomerAvatar from "@/assets/default/customer.png";
import { getDetail } from "@/api/report";
import NoData from "@/components/noData";

export default {
  data() {
    return {
      loading: false,
      defaultCustomerAvatar: defaultCustomerAvatar,
      customerInfo: {},
      list: [],
    };
  },
  watch: {
    $route() {},
  },
  computed: {},
  components: {
    CountItem,
    NoData,
  },
  methods: {
    init() {
      this.loading = true;

      let params = {
        enterpriseId: this.$route.query.enterpriseId,
      };
      if (this.$route.query.token) {
        params.token = this.$route.query.token;
      }

      getDetail(params)
        .then((res) => {
          if (res.data) {
            this.customerInfo = {
              enterpriseId: res.data.enterpriseId,
              enterpriseLogo: res.data.enterpriseLogo,
              enterpriseName: res.data.enterpriseName,
            };
            this.list = res.data.positionList ? res.data.positionList : [];
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.init();
  },
};
</script>
